import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Input, Checkbox } from 'semantic-ui-react';
import Dropdown from './dropDown';
import { fileQryFunction, setLoadingState, getQryFunction } from './actions/qryInputActions';
import { displayDropDownItem } from "./util";
import { toast } from "../../commonComponents/Toast";
import store from "./store";
import { countryList, modeOfTransport } from './countryList';

export class QryInput extends Component {
    constructor(props) {
        super(props);
        let datetommthing = (date) => {
            function pad(str, max) {
                str = str.toString();
                return str.length < max ? pad("0" + str, max) : str;
            }
            return `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(date.getDate(), 2)}`//Let's use local dates for everything as it's all on the UI
        }
        this.state = {
            "MOT": "",
            "ADCVD": {
                "ADCVD-HTS": "",
                "ADCVD-MID": "",
                "ADCVD-CO": ""
            },
            "errorMsg": {
                adcvd: "",
                bol: "",
                cr: "",
                hts: "",
                mid: "",
                ib: "",
                es: ""
            },
            entrySummaryInputList: [{ id: Date.now() + "" + Math.random(), value: '' }],
            criteriaQuery: {
                toDateTimeInput: datetommthing(new Date()),//"toDateTimeInput": "052521120000AM",
                fromDateTimeInput: datetommthing(new Date(Date.now() - 1000 * 60 * 60 * 24 * 30)),//"fromDateTimeInput": "05/25/21/120000AM",
                queryTypeCode: "EES",
                "ftaReconSummariesFlag": "N",
                "otherReconSummaariesFlag": "N",
                "drawbackSummariesFlag": "N",
                "naftaDutyDeferralSummariesFlag": "N",
                "consumptionEntrySummaryFlag": "N"
            }

        }
        this.htsCode = React.createRef();
        console.log(this.props.launchFrom)
        this.submitQryFuncFromOutside = this.submitQryFuncFromOutside.bind(this);
        this.runAgain = this.runAgain.bind(this)
        if (['ISF_HEADER', 'BOL_FORM', 'EN_FORM', 'BOLHeader', 'MERCHANDISE_LINE'].includes(this.props.launchFrom)) {
            this.submitQryFuncFromOutside(this.props.launchFrom, this.props.dataType, { bolIdData: this.props.bolIdData }, props.hts);
        }
    }

    componentDidMount() {
        if (this.props.selectCase) {
            document.getElementById('ADCVD-HTS').focus();
        }
        let enNum = !isNaN(this.props['entryNumber']) ? Number(this.props['entryNumber']).toString() : this.props['entryNumber'];

        let bolIdData = this.props.bolIdData || {};
        let hbolnumber = bolIdData.bol || "";
        let mbolNumber = bolIdData.masterBolNumber || ""
        if (bolIdData.bolType == "2") {
            hbolnumber = "";
        }
        this.setState({
            "ADCVD": {
                "ADCVD_HTS": this.props['ADCVD_HTS'],
                "ADCVD_MID": this.props['ADCVD_MID'],
                "ADCVD_CO": this.props['ADCVD_CO']
            },
            "ES_EN": enNum ? enNum.slice(enNum.length - 8) : '',
            "MOT": bolIdData.modeOfTransport || "",
            "MBOL-Number": mbolNumber,
            "BOL-Number": hbolnumber,

        })

        let entryNumberSubstr = this.props.bolIdData && (this.props.bolIdData.entryNumber + "").substring(3, 99)//this is the case of running from the es query button
        entryNumberSubstr = entryNumberSubstr || (enNum ? enNum.slice(enNum.length - 8) : '');//this is the case of a PSC
        this.setState({ entrySummaryInputList: [{ value: entryNumberSubstr, id: 123 }] })
        this.setState({ 'Entry-Number': entryNumberSubstr })
        if (this.props.launchFrom === 'ESHeader') {
            console.error('ESHeader: ');
            for (let ixxx of [0, 800]) {
                setTimeout(() => {
                    console.error('ESHeader2: ');
                    this.submitQryFunc({ currentTarget: { dataset: { type: "ES" } } });
                }, 1600 + ixxx)
            }
        }
    }

    componentDidUpdate() {
        if (this.props.runAgainClicked) {
            this.runAgain(this.props.launchFrom, this.props.dataType, this.props.value, this.props.mBol, this.props.hts)
            //console.log("runAgainClicked");
        }
        if (this.props.startedReconcile) {
            this.runAgain(this.props.launchFrom, this.props.dataType, this.props.value, this.props.mBol, this.props.hts, true)
        }
    }
    setAdCvdState = (element, evt, val) => {
        const adcvdState = Object.assign({}, this.state);
        if (val) {
            adcvdState['ADCVD'][element] = val
        }
        adcvdState['ADCVD'][element] = evt.target.value
        if (element != '') {
            this.setState({
                "ADCVD": adcvdState['ADCVD']
            })
        }
    }
    setArbitraryState = (element, evt, val) => {
        let value = (val && val.value) || evt.target.value || val
        if (typeof value == "object") value = "";
        this.setState({
            [element]: value
        })

    }
    setEsEnState = (element, evt, val) => {
        const esState = Object.assign({}, this.state);
        if (val) {
            esState['ES_EN'] = val
        }
        esState['ES_EN'] = evt.target.value
        this.setState({
            "ES_EN": esState['ES_EN']
        })
    }
    setAdCvdCoState = (element, val) => {
        const adcvdState = Object.assign({}, this.state);
        if (val) {
            adcvdState['ADCVD'][element] = val
            this.setState({
                "ADCVD": adcvdState['ADCVD']
            })
        }
    }

    setFocusOnClick = (e) => {
        e.target.focus();
        e.target.select();
    }

    updateErrorMessage = (errType, message) => {
        let errorMsg = {
            adcvd: "",
            bol: "",
            cr: "",
            hts: "",
            mid: "",
            ib: "",
            es: ""
        }
        errorMsg[errType] = message;
        this.setState({ "errorMsg": errorMsg });
    }

    validateInputData = (inputType, value = '', mBol = '', hts = '') => {
        console.log('gqqvjalidateData: ', this.state);//leaving this for now
        this.props.setQryType(inputType);
        // eslint-disable-next-line default-case
        switch (inputType) {
            case "ADCVD":
                let hts = (this.state['ADCVD']['ADCVD_HTS'] || "").replace(/\./g, "");
                let mid = this.state['ADCVD']['ADCVD_MID'] || "";
                //let co = document.getElementById("ADCVD-CO").value;
                let co = this.state.ADCVD.ADCVD_CO;
                document.getElementById("ADCVD-HTS").focus()
                if (!hts && !mid && !co) {
                    toast.warning("No input provided for AdCvd query function.");
                    return false;
                } else if (!hts || !co) {
                    this.updateErrorMessage("bol", "Not a valid BOL number");
                    toast.warning("HTS and Country Of Origin is mandatory.");
                    return false;
                } else if (hts.length > 10) {
                    this.updateErrorMessage("adcvd", {
                        "hts": "HTS Code Should be of 10 digits."
                    });
                    toast.warning("HTS Code Should be of 10 digits.");
                    return false;
                }
                return {
                    "countryCode": co,
                    "htsNumber": hts,
                    "midCode": mid
                }
            case "BOL":
                let houseBolNumber = value || (this.state['BOL-Number'] || "").trim();
                let mBolNo = mBol || (this.state['MBOL-Number'] || "").trim();
                let mot = this.state.MOT || this.props.mot;

                if (mot !== 'AIR' && houseBolNumber.length > 0 && houseBolNumber.length < 5) {
                    this.updateErrorMessage("bol", "Not a valid HBOL number " + houseBolNumber);
                    toast.warning("Not a valid HBOL number " + houseBolNumber);
                    return false;
                } else if (mot == 'AIR' && houseBolNumber && houseBolNumber.length > 12) {
                    this.updateErrorMessage("bol", "Length of House Air BOL number cannot be greater than 12");
                    toast.warning(`Length of House Air Bill number cannot be greater than 12 '${houseBolNumber}'`);
                    return false;
                } else if (mot === 'AIR' && !mBolNo) {
                    this.updateErrorMessage("bol", "Master Air Bill number is mandatory");
                    toast.warning("Master Air Bill number is mandatory");
                    return false;
                } else if (mot == 'AIR' && mBolNo.length > 11) {
                    this.updateErrorMessage("bol", "Length of Master Air BOL number cannot be greater than 11");
                    toast.warning(`Length of Master Air Bill number cannot be greater than 11 '${mBolNo}'`);
                    return false;
                } else if (mot == 'AIR' && !houseBolNumber &&
                    (mBolNo.startsWith("406") || mBolNo.startsWith("023") || mBolNo.startsWith("936"))
                ) {
                    this.updateErrorMessage("bol", "Length of Master Air BOL number cannot be greater than 11");
                    toast.warning("MAWB queries beginning with 023, 406, and 936 are too large. Add a house bol.", { duration: 5000 });
                    return false;

                } else if (houseBolNumber.length > 16) {
                    this.updateErrorMessage("bol", "Length of  BOL number cannot be greater than 16");
                    toast.warning("Length of  BOL number cannot be greater than 16");
                    return false;
                }
                return {
                    "bolNumber": houseBolNumber,
                    "mBolNumber": mBolNo
                }
            case "CR":
                let entryNo = (this.state['Entry-Number'] || "").trim();
                if (!entryNo) {
                    toast.warning("No input provided for CR query function.");
                    return false;
                } else if (entryNo.length !== 8) {
                    this.updateErrorMessage("cr", "Entry number cannot greater than 8");
                    toast.warning(`Length of Entry number should be 8: ${entryNo}`);
                    return false;
                }
                return {
                    "entryNumber": entryNo
                }
            case "ES":
                if (false) {
                    let entryNum = value || (document.getElementById('Entry-Num').value).trim();
                    if (!entryNum) {
                        toast.warning("No input provided for Entry summary query function.");
                        return false;
                    } else if (entryNum.length !== 8) {
                        this.updateErrorMessage("es", "Entry number cannot greater than 8");
                        toast.warning("Length of Entry number should be 8");
                        return false;
                    }
                }
                return {
                    "entrySummaryInputList": this.state.entrySummaryInputList
                }
            case "CRITERIAQUERYQQ":
                return this.state.criteriaQuery;
            case "HTS":
                let htsCode = (this.state['Hts-Code'] || this.props.hts || "").replace(/\./g, "").trim();
                let asOfDate;
                if (this.state.asOfDate) {
                    const dateString = this.state.asOfDate.split("-")
                    asOfDate = "" + dateString[1] + dateString[2] + dateString[0].substring(2)
                }
                else {
                    let today = new Date()
                    if (this.props.asOfDate) {
                        today = new Date(this.props.asOfDate)
                    }
                    const dd = today.getUTCDate()
                    const mm = today.getUTCMonth() + 1
                    const yy = parseInt(today.getUTCFullYear().toString().substring(2))
                    asOfDate = "" + (mm < 10 ? 0 : "") + mm + (dd < 10 ? 0 : "") + dd + (yy < 10 ? 0 : "") + yy;
                }
                if (!htsCode) {
                    toast.warning("No input provided for HTS query function.");
                    return false;
                } else if (htsCode.length < 10) {
                    if (!(htsCode.length === 6 || htsCode.length === 8)) {
                        this.updateErrorMessage("hts", "HTS Code Should be of 10, 8 or 6 digits.");
                        toast.warning("HTS Code Should be of 10, 8 or 6 digits.");
                        return false;
                    }
                    if (htsCode.length === 6) {
                        return {
                            "fromHtsNo": htsCode,
                            "toHtsNo": htsCode + "9999",
                            "asOfDate": asOfDate
                        }
                    } else if (htsCode.length === 8 && !htsCode.startsWith("99")) {
                        return {
                            "fromHtsNo": htsCode,
                            "toHtsNo": htsCode + "99",
                            "asOfDate": asOfDate
                        }
                    }
                }

                return {
                    "fromHtsNo": htsCode,
                    "asOfDate": asOfDate
                }
            case "MID":
                let midNumber = (this.state['Mid-Num'] || "").trim();
                if (!midNumber) {
                    toast.warning("No input provided for MID query function.");
                    return false;
                } else if (midNumber.length > 15) {
                    this.updateErrorMessage("mid", "Maximum length of MID should be 15");
                    toast.warning("Maximum length of MID should be 15");
                    return false;
                }
                return {
                    "mid": midNumber
                }
            case "IB":
                let importerNumber1 = (this.state['Importer-Num'] || "").trim();
                if (!importerNumber1) {
                    toast.warning("No input provided for Importer and Bond query function.");
                    return false;
                } else if (importerNumber1.length > 12) {
                    this.updateErrorMessage("ib", "Maximum length of Importer No. should be 12");
                    toast.warning("Maximum length of Importer No. should be 12");
                    return false;
                }
                return {
                    "importerNumber1": importerNumber1
                }
        }
    }

    submitQryFuncFromOutside = (launchFrom, inputType, additionalDataParamtt, hts) => {
        let docType = "DOC_CR_BOL_QUERY_REQUEST";
        if (inputType == "ES") {
            docType = "GET_ENTRY_SUMMARY_QUERY_RESPONSE";
        }
        else if (inputType === 'HTS') {
            docType = "GET_HTS_QUERY_RESPONSE";
        }
        this.props.setQryType(inputType);
        store.dispatch(setLoadingState());
        if (inputType != "BOL") {
            if (launchFrom === 'MERCHANDISE_LINE') {
                this.runAgain(launchFrom, inputType, hts, "", hts);
            } else {
                store.dispatch(getQryFunction(this.props.shipId, docType, inputType, additionalDataParamtt, hts));
            }
        }
    }

    runAgain = (launchFrom, inputType, value, mBol, hts, forReconciliation = false) => {
        if (launchFrom == "BOLHeader") {
            mBol = this.state['MBOL-Number'] || mBol;
            value = this.state['BOL-Number'] || value;
        }
        window.qryTimeout = true;
        let validateData = this.validateInputData(inputType, value, mBol, hts);
        let page = this.props.page;
        let brokerGuid = (this.props.bolIdData && this.props.bolIdData.brokerGuid) || "";
        if (validateData) {
            store.dispatch(setLoadingState());
            store.dispatch(fileQryFunction({
                qryType: inputType,
                brokerId: this.props.brokerId || this.props.brokerGuid,
                shipmentId: this.props.shipId || this.props.shipmentId,
                useKNCred: this.props.useKNCred,
                mot: this.props.mot,
                params: validateData,
                page: page,
                forReconciliation: forReconciliation
            }));
            if (forReconciliation) {
                this.props.unSetStartReconcileClicked();
            }
            else {
                this.props.unSetRunAgainClicked();
            }
        } else {
            if (forReconciliation) {
                this.props.unSetStartReconcileClicked();
            }
            else {
                this.props.unSetRunAgainClicked();
            }
        }
    }

    submitQryFunc = (evt) => {
        window.qryTimeout = true;
        let inputType = evt.currentTarget.dataset.type;
        let validateData = this.validateInputData(inputType);
        let page = this.props.page;
        this.props.parentThis && this.props.parentThis.setState({ qryTypeFoo: inputType })
        if (validateData) {
            store.dispatch(setLoadingState());
            store.dispatch(fileQryFunction({
                qryType: inputType,
                shipmentId: this.props.shipId || this.props.shipmentId,
                brokerId: this.props.brokerId,
                useKNCred: this.props.useKNCred || null,
                mot: this.state.MOT || null,
                params: validateData,
                page: page
            }));
        }
    }

    render() {
        let criteriaTypes =
            [{ id: "AII", value: "AII", text: "Automated Invoice Interface" },
            { id: "PSC", value: "PSC", text: "Post Summary Correction" },
            { id: "EES", value: "EES", text: "Every Entry Summary" },
            { id: "DOC", value: "DOC", text: "Docs Requested" },
            { id: "RCN", value: "RCN", text: "flagged Reconciliation" },
            { id: "LIQ", value: "LIQ", text: "Liquidated" },
            { id: "NLQ", value: "NLQ", text: "Not Liquidated" },]
        let { criteriaQuery } = this.state;
        let { filerCode } = this.props;
        let { launchFrom } = this.props;
        //  const ADCVD_HTS = this.props.ADCVD_HTS;
        return (
            <div className={'qryInputList'}>
                {
                    this.props.launchFrom === 'ESHeader' ? (
                        <div className={`qryInputBox es-box`}>
                            <label>Entry Summary Query</label>
                            <Input
                                id="Entry-Num"
                                type="text"
                                placeholder="Entry No."
                                name='Entry-Num'
                                value={this.state['ES_EN']}
                                onChange={this.setEsEnState.bind(this, 'Entry-Num')}
                                onClick={this.setFocusOnClick} />
                            <div className={`submitButtonText`} data-type='ES'
                                onClick={
                                    this.submitQryFunc
                                }
                            >
                                Submit
                            </div>
                        </div>
                    ) :

                        !this.props.selectCase &&
                        <React.Fragment>
                            <div className={`qryInputBox bol-box`}>
                                <label>BOL Query</label>
                                <div>
                                    <Dropdown
                                        id="MOT"
                                        name='MOT'
                                        className={`qryDropdown`}
                                        onChange={(value) => {
                                            this.setState({ 'MOT': value })
                                        }
                                        }
                                        style={{ "width": "100%", "minHeight": "31px", "border": "1px solid #ccc" }}
                                        placeholder="MOT"
                                        value={this.state['MOT']}
                                        text={this.state['MOT'] ? displayDropDownItem(this.state['MOT'], modeOfTransport) : ""}
                                        data={modeOfTransport}
                                    />
                                </div>
                                <div>
                                    <Input id="BOL-Number" placeholder={this.state['MOT'] === 'TRUCK' ? "PAPS" : (this.state['MOT'] === 'AIR' ? "HBOL" : "BOL")} name='BOL'
                                        value={this.state['BOL-Number']}
                                        onChange={this.setArbitraryState.bind(this, 'BOL-Number')}
                                    />
                                </div>
                                {
                                    this.state['MOT'] === 'AIR' &&
                                    <div>
                                        <Input id="MBOL-Number" placeholder="MBOL" name='MBOL'
                                            value={this.state['MBOL-Number']}
                                            onChange={this.setArbitraryState.bind(this, 'MBOL-Number')}
                                        />
                                    </div>
                                }
                                <div className={`submitButtonText`} data-type='BOL'
                                    onClick={
                                        this.submitQryFunc
                                    }
                                >
                                Submit
                            </div>
                            </div>
                            {
                                launchFrom !== 'opsAdmin' &&
                                <React.Fragment>
                                    <div className={`qryInputBox cr-box`}>
                                        <label>Cargo Release Query</label>
                                        <Input id="Entry-Number" type="text" placeholder="Entry No." name='Entry-Number'
                                            value={this.state['Entry-Number']}
                                            onChange={this.setArbitraryState.bind(this, 'Entry-Number')}
                                        />
                                        <div className={`submitButtonText`} data-type='CR'
                                            onClick={
                                                this.submitQryFunc
                                            }
                                        >
                                Submit
                            </div>
                                    </div>
                                    <div className={`qryInputBox es-box`}>
                                        <label>Entry Summary Query</label>
                                        {this.state.entrySummaryInputList.map((esinputval, iiix) => {
                                            return <div key={esinputval.id} className="qryEsField">
                                                {this.state.entrySummaryInputList.length > 1 && <Icon name='trash'
                                                    className="qryEsTrash"
                                                    onClick={() => {
                                                        this.setState({ entrySummaryInputList: this.state.entrySummaryInputList.filter((a) => a.id != esinputval.id) })
                                                    }}
                                                />}
                                                <Input

                                                    label={{ basic: true, content: filerCode ? (filerCode + " - ") : '### - ' }}
                                                    labelPosition='left'
                                                    className = 'entryNumfield'
                                                    value={esinputval.value} id="Entry-Num" type="text" placeholder="Entry No." name='Entry-Num'
                                                    onChange={(e) => {
                                                        let templist = this.state.entrySummaryInputList;
                                                        templist[iiix].value = e.target.value;
                                                        this.setState({ entrySummaryInputList: templist })
                                                    }}
                                                />
                                            </div>
                                        })}
                                        <div className={`submitButtonText`} data-type='ES'
                                            onClick={
                                                this.submitQryFunc
                                            }
                                        >
                                            Submit
                                        </div>
                                        <br />
                                        <a href="#" className='submitButtonText'
                                            onClick={(e) => {
                                                let templist = this.state.entrySummaryInputList;
                                                templist.push({ id: Date.now() + "" + Math.random(), value: '' });
                                                this.setState({ entrySummaryInputList: templist })
                                            }}>

                                            Add Entry Number
                                        </a>
                                    </div>
                                    <div className={`qryInputBox hts-box`}>
                                        <label>Entry Summary Criteria Query</label>
                                        <div>
                                            <div style={{ display: 'inline-block', width: '70px' }}>Start Date</div>
                                            <input type="date"
                                                value={"" + criteriaQuery.fromDateTimeInput}
                                                onChange={(event) => {
                                                    criteriaQuery.fromDateTimeInput = event.target.value;
                                                    this.setState({ criteriaQuery: criteriaQuery })
                                                }}
                                            />
                                        </div>
                                        <div style={{ paddingBottom: '2px', display: 'inline-block' }}>
                                            <div style={{ display: 'inline-block', width: '70px' }}>End Date</div>
                                            <input type="date"
                                                value={"" + criteriaQuery.toDateTimeInput}
                                                onChange={(event) => {
                                                    criteriaQuery.toDateTimeInput = event.target.value;
                                                    this.setState({ criteriaQuery: criteriaQuery })
                                                }}
                                            />
                                        </div>
                                        {/* start submit button*/}
                                        {new Date(criteriaQuery.toDateTimeInput) <= new Date(criteriaQuery.fromDateTimeInput) ?
                                            <div><small>From Date must be before To Date</small></div> :
                                            (new Date(criteriaQuery.toDateTimeInput).getTime() - new Date(criteriaQuery.fromDateTimeInput).getTime()) / (1000 * 60 * 60 * 24) > 31 ?
                                                <div><small>Date range must be less than 31 days</small></div> :
                                                <div className={`submitButtonText`} data-type='CRITERIAQUERYQQ'
                                                    onClick={
                                                        this.submitQryFunc
                                                    }
                                                >
                                Submit
                            </div>
                                        }
                                        {/* end submit button*/}
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a href="#" onClick={() => { this.setState({ showAllCriteriaOptions: !this.state.showAllCriteriaOptions }) }}>{this.state.showAllCriteriaOptions ? 'Hide' : 'Show'} filters...</a>
                                        <br />
                                        {this.state.showAllCriteriaOptions && <React.Fragment>
                                            <Dropdown
                                                className={`qryDropdown`}
                                                onChange={(value) => {
                                                    console.log('value: ', value);
                                                    criteriaQuery.queryTypeCode = value;
                                                    this.setState({ criteriaQuery: criteriaQuery })
                                                }}
                                                value={criteriaQuery.queryTypeCode}
                                                text={displayDropDownItem(criteriaQuery.queryTypeCode, criteriaTypes)}
                                                data={criteriaTypes}
                                            />
                                            <Checkbox
                                                label='FTA recon Summaries'
                                                checked={criteriaQuery.ftaReconSummariesFlag === 'Y'}
                                                onChange={() => {
                                                    criteriaQuery.ftaReconSummariesFlag = criteriaQuery.ftaReconSummariesFlag == 'N' ? 'Y' : 'N';
                                                    this.setState({ criteriaQuery: criteriaQuery });
                                                }} />
                                            <Checkbox
                                                label='Other recon Summaries'
                                                checked={criteriaQuery.otherReconSummaariesFlag === 'Y'}
                                                onChange={() => {
                                                    criteriaQuery.otherReconSummaariesFlag = criteriaQuery.otherReconSummaariesFlag == 'N' ? 'Y' : 'N';
                                                    this.setState({ criteriaQuery: criteriaQuery });
                                                }} />
                                            <Checkbox
                                                label='Drawback recon'
                                                checked={criteriaQuery.drawbackSummariesFlag === 'Y'}
                                                onChange={() => {
                                                    criteriaQuery.drawbackSummariesFlag = criteriaQuery.drawbackSummariesFlag == 'N' ? 'Y' : 'N';
                                                    this.setState({ criteriaQuery: criteriaQuery });
                                                }} />
                                            <Checkbox
                                                label='NAFTA duty deferral'
                                                checked={criteriaQuery.naftaDutyDeferralSummariesFlag === 'Y'}
                                                onChange={() => {
                                                    criteriaQuery.naftaDutyDeferralSummariesFlag = criteriaQuery.naftaDutyDeferralSummariesFlag == 'N' ? 'Y' : 'N';
                                                    this.setState({ criteriaQuery: criteriaQuery });
                                                }} />
                                            <Checkbox
                                                label='Consumption entry'
                                                checked={criteriaQuery.consumptionEntrySummaryFlag === 'Y'}
                                                onChange={() => {
                                                    criteriaQuery.consumptionEntrySummaryFlag = criteriaQuery.consumptionEntrySummaryFlag == 'N' ? 'Y' : 'N';
                                                    this.setState({ criteriaQuery: criteriaQuery });
                                                }} />
                                        </React.Fragment>}
                                    </div></React.Fragment>
                            }
                            <div className={`qryInputBox hts-box`}>
                                <label>HTS Query</label>
                                <div>
                                    <Input id="Hts-Code" name='Hts-code' placeholder="FROM HTS"
                                        value={this.state['Hts-Code']}
                                        onChange={this.setArbitraryState.bind(this, 'Hts-Code')}
                                    />
                                </div>
                                {
                                    this.state['Hts-Code'] && (this.state['Hts-Code'].length === 6 || (this.state['Hts-Code'].length === 8 && !this.state['Hts-Code'].startsWith("99"))) &&
                                    <React.Fragment>
                                        <div style={{ "textAlign": "center", "fontWeight": "bold", "marginTop": "3px", "marginBottom": "3px" }}>
                                            TO
                                        </div>
                                        <div>
                                            <Input id="to-Hts-Code" name='to-Hts-Code' placeholder="TO HTS"
                                                value={this.state['Hts-Code'].length === 6 ? (this.state['Hts-Code'].startsWith("99") ? this.state['Hts-Code'] + "99" : this.state['Hts-Code'] + "9999") : (this.state['Hts-Code'].length === 8 ? this.state['Hts-Code'] + "99" : "")}
                                                disabled
                                            />
                                        </div>
                                    </React.Fragment>
                                }
                                <div style={{ display: 'inline-block', width: '70px' }}>As of Date</div>
                                <input type="date"
                                    value={this.state['asOfDate']}
                                    onChange={(event) => {
                                        this.setState({ asOfDate: event.target.value })
                                    }}
                                />
                                <div className={`submitButtonText`} data-type='HTS'
                                    onClick={
                                        this.submitQryFunc
                                    }
                                >
                                Submit
                            </div>
                            </div>
                            <div className={`qryInputBox mid-box`}>
                                <label>MID CBP Query</label>
                                <Input id="Mid-Num" name='Mid-Num' placeholder="MID"
                                    value={this.state['Mid-Num']}
                                    onChange={this.setArbitraryState.bind(this, 'Mid-Num')}

                                />
                                <div className={`submitButtonText`} data-type='MID'
                                    onClick={
                                        this.submitQryFunc
                                    }
                                >
                                Submit
                            </div>
                            </div>
                            <div className={`qryInputBox ib-box`}>
                                <label>IMPORTER & BOND Query</label>
                                <Input id="Importer-Num" name='Importer-Num' placeholder="Importer No."

                                    value={this.state['Importer-Num']}
                                    onChange={this.setArbitraryState.bind(this, 'Importer-Num')}
                                />
                                <div className={`submitButtonText`} data-type='IB'
                                    onClick={
                                        this.submitQryFunc
                                    }
                                >
                                Submit
                            </div>
                            </div>
                        </React.Fragment>
                }
                {
                    this.props.launchFrom !== 'ESHeader' &&
                    <div className={`qryInputBox adcvd-box`} id='adcvd-box'>
                        <label>AD/CVD Query</label>
                        <div>
                            <Input
                                id="ADCVD-HTS"
                                name='ADCVD-HTS'
                                placeholder="HTS"
                                onClick={this.setFocusOnClick}
                                onChange={this.setAdCvdState.bind(this, 'ADCVD_HTS')}
                                value={this.state['ADCVD']['ADCVD_HTS']} />
                        </div>
                        <div>
                            <Input
                                id="ADCVD-MID"
                                name='ADCVD-MID'
                                placeholder="MID"
                                onClick={this.setFocusOnClick}
                                onChange={this.setAdCvdState.bind(this, 'ADCVD_MID')}
                                value={this.state['ADCVD']['ADCVD_MID']} />
                        </div>
                        <div style={{ "marginTop": "3px" }}>
                            <Dropdown
                                id="ADCVD-CO"
                                name='ADCVD-CO'
                                className={`qryDropdown`}
                                onChange={(value) => {
                                    debugger;
                                    this.setAdCvdCoState('ADCVD_CO', value)
                                }
                                }
                                style={{ "width": "100%", "minHeight": "31px", "border": "1px solid #ccc" }}
                                placeholder="CO"
                                value={this.state['ADCVD'].ADCVD_CO}
                                text={this.props.ADCVD_CO ? displayDropDownItem(this.state['ADCVD'].ADCVD_CO,
                                    countryList) : ""}
                                data={countryList}
                            />
                            {/* <select id="ADCVD-CO" name='ADCVD-CO' onChange={this.setAdCvdState.bind(this, 'ADCVD_CO')} style={{"marginLeft": "9px", "width": "78%", "height": "29px"}} placeholder="CO" value={this.props.ADCVD_CO}>
                      <option value=''>Country Of Origin</option>
                      {
                          countryList.map((item)=>{
                                return (
                                <option value={item.id} selected = {item.id === this.state['ADCVD']['ADCVD_CO']?' selected': ''}>
                                    {item.value+' - '+item.text}
                                </option>
                                )
                          })
                      }
                   </select>      */}

                            <div className={`submitButtonText`} data-type='ADCVD'
                                onClick={
                                    this.submitQryFunc
                                }
                            >
                                Submit
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    qryInput: state.QryInput,
    page: state.page
})
const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QryInput)